import { UseMutationOptions, useMutation } from "react-query";
import { http } from "./http";

export type ChatLine = {
    role: 'assistant' | 'user' | 'system',
    content: string
}

export function useAiChatMutation(ops?: UseMutationOptions<any, any, any, any>) {
    return useMutation({
        ...ops,
        mutationFn: (lines: ChatLine[]) => http(`/api/ai/chat`, {
            method: "POST",
            body: lines
        })
    });
}